import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { useDispatch, useSelector } from "react-redux";
import { leftArrow, rightArrow } from "../../../assets/img";
import DSOButton from "../../UI/button/DSOButton";
import ProductItemCardThumb from "../product-item-card-thumb/ProductItemCardThumb";
import Theme from "../../../constants/theme";
import welcomeReducer from "../../../modules/welcome/redux/welcome.reducer";
import PageRoutes from "../../../constants/page-routes";
import { useHistory } from "react-router-dom";

const Index = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = sessionStorage.getItem(Theme.KEY);

  const { isExistingUser } = useSelector(({ loginReducer }) => loginReducer);
  const { existingCusDetails } = useSelector(({ consoleReducer }) => consoleReducer);

  return (
    <>
      <div
        className={`footer-outer-wrapper mobile__main-footer-wrapper ${props.option} 
            ${props.isMobile ? "mobile_menu" : "desktop_menu"}`}>
        <div className={`form-footer-wrapper ${theme} d-flex d-flex justify-content-between`}>
          <div className={"footer-product-wrapper desktop_footer d-flex align-items-center"}>
            {theme === null &&
              existingCusDetails?.product?.map((product, index) => (
                <div className={"product-item-row d-flex"} style={{ alignItems: "center" }} key={index}>
                  <ProductItemCardThumb
                    product={{
                      ImageUrl: product.ProductImage,
                      ProductName: product.ProductName,
                      Cur: product.Cur,
                    }}
                  />
                </div>
              ))}
          </div>
          {/* end footer-product-wrapper */}

          <div className={`cta-wrapper ${theme} d-flex align-items-center`}>
            {props.formStep === 1 && isExistingUser ? (
              <div className="d-flex gap-10 mobile-buttons-footer-wrapper">
                <DSOButton
                  text="Visit Branch"
                  btnType="back"
                  leftIcon={leftArrow}
                  onClick={() => {
                    dispatch(welcomeReducer.actions.setActive(5));
                    history.push(`/${PageRoutes.WELCOME}`);
                  }}
                />

                <DSOButton
                  text="Proceed"
                  btnType="next"
                  rightIcon={rightArrow}
                  onClick={() => {
                    props.onClickNext();
                  }}
                />
              </div>
            ) : (
              <div className="d-flex gap-10 mobile-buttons-footer-wrapper">
                <DSOButton
                  text="Back"
                  btnType="back"
                  leftIcon={leftArrow}
                  className="w-108"
                  onClick={() => {
                    props.onClickBack();
                  }}
                />

                <DSOButton
                  text="Next"
                  btnType="next"
                  rightIcon={rightArrow}
                  className="w-108"
                  onClick={() => {
                    props.onClickNext();
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Index;
